import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Panel } from './Panel';

export type LinkItem = { label: string; to: string; count?: number };

/** A box of links to other pages, each with an optional count: "Quotations  2  >" */
export function LinksPanel({ title, items }: { title: string; items: LinkItem[] }) {
  return (
    <Panel title={title}>
      <Stack>
        {items.map((r) => (
          <Link
            key={r.label}
            component={RouterLink}
            to={r.to}
            underline="none"
            sx={{ display: 'flex', alignItems: 'center', py: 0.75, gap: 1 }}
          >
            <Box sx={{ flex: 1 }}>{r.label}</Box>
            {r.count !== undefined && (
              <Typography variant="caption" color="text.secondary">
                {r.count}
              </Typography>
            )}
            <ChevronRight fontSize="small" />
          </Link>
        ))}
      </Stack>
    </Panel>
  );
}
